export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 90,
    visible: !that.disabled,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号',
    field: 'orderGoodsNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsName') || '产品名称',
    field: 'orderGoodsDisplayName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
